import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Redirect } from "react-router-dom";
// import AddArticle from '../DiscoverNew/Components/AddArticle';
import Discover from "../DiscoverNew";
import Landing from "../Landing";
import userStore from "../../Stores/User";
import queryString from "query-string";
import loading from "../../Assets/loading.gif";

const ContentSwitch = observer(({ history }) => {
  const pathname = history.location.pathname;
  const USER_ID = queryString.parse(history.location.search).USER_ID;

  useEffect(() => {
    console.log("userStore.isSignedIn", userStore.isSignedIn)
    if (userStore.isSignedIn) {
      // Use matchMedia instead of direct window.innerWidth check
      const isMobileView = window.matchMedia("(max-width: 1199.98px)").matches;
      // Change the CSS .intercom-lightweight-app-launcher bottom
      if (isMobileView) {
        document.documentElement.style.setProperty('--chat-bubble-bottom', '180px');
      } else {
        document.documentElement.style.setProperty('--chat-bubble-bottom', '106px');
      }
      
      // Add listener for screen size changes
      const mediaQueryList = window.matchMedia("(max-width: 1199.98px)");
      const handleMediaChange = (e) => {
        if (e.matches) {
          document.documentElement.style.setProperty('--chat-bubble-bottom', '180px');
        } else {
          document.documentElement.style.setProperty('--chat-bubble-bottom', '106px');
        }
      };
      
      mediaQueryList.addEventListener('change', handleMediaChange);
      
      return () => {
        mediaQueryList.removeEventListener('change', handleMediaChange);
      };
    } else {
      document.documentElement.style.setProperty('--chat-bubble-bottom', '106px');
    }
  }, [userStore.isSignedIn])

  if (userStore.isSignedIn === true) {
    return <Discover />;
  }

  if (userStore.isSignedIn === false) {
    if (pathname !== "/") {
      // Always preserve all URL parameters when redirecting to signin
      const searchParams = new URLSearchParams(history.location.search);
      const currentParams = searchParams.toString();
      
      // Add source parameter if not present
      if (!searchParams.has('source')) {
        searchParams.set('source', pathname.slice(1) || 'landing');
      }
      
      if (USER_ID) {
        return <Redirect to={`/signin/${USER_ID}?${searchParams.toString()}`} />;
      } else {
        return <Redirect to={`/signin?${searchParams.toString()}`} />;
      }
    } else {
      // Preserve ALL URL parameters when showing landing page
      const searchParams = new URLSearchParams(history.location.search);
      const currentParams = searchParams.toString();
      
      // If we have params but they're not in the URL, update the URL
      if (currentParams && !history.location.search) {
        history.replace({
          pathname: '/',
          search: currentParams
        });
      }
      
      // Create a new Landing component with a key that includes all search params
      return <Landing key={searchParams.toString()} />;
    }
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#180f22',
      zIndex: 1000
    }}>
      <div style={{
        position: 'relative',
        width: '120px',
        height: '120px',
        marginBottom: '20px'
      }}>
        <img 
          src="/logo192.png" 
          alt="Audioread" 
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            animation: 'pulse 2s infinite'
          }}
        />
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '140px',
          height: '140px',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: 'rgb(255 143 65)',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
      </div>
      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.1); opacity: 0.8; }
            100% { transform: scale(1); opacity: 1; }
          }
          @keyframes spin {
            0% { transform: translate(-50%, -50%) rotate(0deg); }
            100% { transform: translate(-50%, -50%) rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
});

export default ContentSwitch;
